import * as api from './api';
import types from './types';
import trim from 'lodash/trim';
import get from 'lodash/get';

import HTTPError from '~/misc/HTTPError';
import {promiseAction, failAction, ActionError} from '~/misc/dispatch';
import {regDot, regMc} from '~/misc/reg';
import {errorInfoConfig} from '~/misc/error-info';
import {getUserData} from '~/modules/user/actions';

export const getSwitchData = () => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.GET_SWITCH_DATA,
  api.asyncSwitch(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const dotMcSwitch = () => (dispatch, getState) => promiseAction(
  dispatch,
  getState,
  types.DOT_MC_SWITCH,
  api.asyncDotMcSwitch(getState).catch(error => {
    if (!(error instanceof HTTPError)) {
      throw error;
    }
    return error.response.json().then(body => {
      const e = get(body, 'api_errors', [])[0] || {};
      if (e.type === 'auth' && e.value === 'token_invalid') {
        throw new ActionError('token_invalid');
      }
      throw error;
    });
  })
);

export const verifyDotMc = ({dot, mc}) => (dispatch, getState) => {
  if (!dot && !mc) {
    return failAction(dispatch, types.VERIFY_DOT_MC, errorInfoConfig.dot.empty);
  }

  if (Boolean(dot) && !regDot.test(dot)) {
    return failAction(dispatch, types.VERIFY_DOT_MC, errorInfoConfig.dot.wrong);
  }

  if (Boolean(mc) && !regMc.test(mc)) {
    return failAction(dispatch, types.VERIFY_DOT_MC, errorInfoConfig.mc.wrong);
  }

  return promiseAction(dispatch, getState, types.VERIFY_WRAP,
    promiseAction(
      dispatch,
      getState,
      types.VERIFY_DOT_MC,
      api.verifyDotMc(getState, trim(dot), trim(mc)).catch(error => {
        const status = error.response.status;
        if (status === 500) {
          throw new ActionError('token error');
        }
        throw error;
      })
    )
      .then(() => {
        const token = getState().user.token;
        return getUserData(dispatch, getState, token);
      })
  );
};



// WEBPACK FOOTER //
// ./src/modules/dots/actions.js